import {} from "../half-edge/index.js";
import {} from "../port/index.js";
import {} from "./Net.js";
import { findHalfEdgeEntryOrFail } from "./findHalfEdgeEntryOrFail.js";
export function findHalfEdgePort(net, halfEdge) {
    const halfEdgeEntry = findHalfEdgeEntryOrFail(net, halfEdge);
    return halfEdgeEntry.port;
}
//# sourceMappingURL=findHalfEdgePort.js.map